// extracted by mini-css-extract-plugin
export default {"trigger":"BCLplV77DposoHynD0Or","dot":"k6NAhwDDJu8mAYG5ktF0"};